/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffair1/style.css';
import FormStructure from './thecateredaffair1/form_structure';

export default FormStructure;